import React, { Fragment } from "react";
import { isDisplayable } from "util/misc";
import GameField from "games/GameField";
import _ from "lodash";

const FootballFields = (props) => {
  return (
    <Fragment>
      <GameField label="Total Points" inputName="totalPoints" {...props} />
      <GameField
        label="First Quarter Points"
        inputName="firstQuarterPoints"
        {...props}
      />
      <GameField
        label="Second Quarter Points"
        inputName="secondQuarterPoints"
        {...props}
      />
      <GameField
        label="Third Quarter Points"
        inputName="thirdQuarterPoints"
        {...props}
      />
      <GameField
        label="Fourth Quarter Points"
        inputName="fourthQuarterPoints"
        {...props}
      />
      <GameField
        label="Overtime Points"
        inputName="overtimePoints"
        {...props}
      />
      <GameField
        label="Overtime 2 Points"
        inputName="overtime2Points"
        {...props}
      />
      <GameField
        label="Overtime 3 Points"
        inputName="overtime3Points"
        {...props}
      />
      <GameField label="First Downs" inputName="firstDowns" {...props} />
      <GameField label="Total Yards" inputName="totalYards" {...props} />
      <h3>Rushing</h3>
      <GameField label="Rush Attempts" inputName="rushingAttempts" {...props} />
      <GameField label="Rushing Yards" inputName="rushingYards" {...props} />
      <GameField
        label="Rushing Touchdowns"
        inputName="rushingTouchdowns"
        {...props}
      />
      <GameField
        label="Rushing Average"
        inputName="rushingAverage"
        disabled
        helperText="yards per rush attempt"
        {...props}
      />
      <h3>Passing</h3>
      <GameField
        label="Pass Completions"
        inputName="passingCompletions"
        {...props}
      />
      <GameField label="Pass Attempts" inputName="passingAttempts" {...props} />
      <GameField
        label="Pass Interceptions"
        inputName="passingInterceptions"
        {...props}
      />
      <GameField label="Passing Yards" inputName="passingYards" {...props} />
      <GameField
        label="Passing Touchdowns"
        inputName="passingTouchdowns"
        {...props}
      />
      <GameField
        label="Pass Interception Yards"
        inputName="passingInterceptionYards"
        {...props}
      />
      <GameField
        label="Passing Average"
        inputName="passingAverage"
        disabled
        helperText="yards per pass attempt"
        {...props}
      />
      <GameField
        label="Passing Completion Percentage"
        inputName="passingCompletionPercentage"
        disabled
        transform={(val) => {
          if (!isDisplayable(val)) return "";
          return `${_.round(val * 100, 2)}%`;
        }}
        {...props}
      />
      <h3>Receiving</h3>
      <GameField label="Receptions" inputName="receptions" {...props} />
      <GameField
        label="Receiving Yards"
        inputName="receivingYards"
        {...props}
      />
      <GameField
        label="Receiving Touchdowns"
        inputName="receivingTouchdowns"
        {...props}
      />
      <GameField
        label="Receiving Average"
        inputName="receivingAverage"
        helperText="yards per reception"
        disabled
        {...props}
      />
      <h3>Punts</h3>
      <GameField label="Punts" inputName="punts" {...props} />
      <GameField label="PuntingYards" inputName="puntingYards" {...props} />
      <GameField
        label="Punting Average"
        inputName="puntingAverage"
        disabled
        {...props}
      />
      <h3>Penalties</h3>
      <GameField label="Penalties" inputName="penalties" {...props} />
      <GameField label="Penalty Yards" inputName="penaltyYards" {...props} />
      <h3>Fumbles</h3>
      <GameField label="Fumbles" inputName="fumbles" {...props} />
      <GameField label="Fumbles Lost" inputName="fumblesLost" {...props} />
      <h3>Field Goals</h3>
      <GameField
        label="Field Goal Attempts"
        inputName="fieldGoalAttempts"
        {...props}
      />
      <GameField
        label="Field Goals Made"
        inputName="fieldGoalsMade"
        {...props}
      />
      <GameField
        label="Field Goal Yards"
        inputName="fieldGoalYards"
        {...props}
      />
      <h3>PATs</h3>
      <GameField
        label="PAT Attempts"
        inputName="pointAfterTouchdownAttempts"
        {...props}
      />
      <GameField
        label="PATs Made"
        inputName="pointAfterTouchdownsMade"
        {...props}
      />
      <h3>Allowed</h3>
      <GameField
        label="Points Allowed"
        inputName="pointsAllowed"
        disabled
        {...props}
      />
      <GameField
        label="Yards Allowed"
        inputName="yardsAllowed"
        disabled
        {...props}
      />
    </Fragment>
  );
};

export default FootballFields;
